module.exports = __webpack_public_path__ + "img/iOS.832c8f2.png";